import i18n from '@/i18n'
import ManagementLayout from '../layout/managementLayout.vue'
import ajingaPolicyManagement from './ajingaPolicyManagement/route'
import defaultNotificationManagement from './notificationManagement/route'
import { TAB_CATEGORY } from '@/constant/permission'
import jobPostRecordRoute from './jobBoardPointDashboard/route'
import companyApprovalRoute from './companyApprovalManagement/route'
import openApiRoute from './openApi/route'
import sourceChannelManagementRoute from './sourceChannelManagement/route'
import candidateStatusManagementRoute from './candidateStatusManagement/route'
import siteMessageManagementRoute from './siteMessageManagement/route'
import serviceAccountManagementRoute from './serviceAccountManagement/route'
import userManagementRoute from './userManagement/route'
import adsTierManagementRoute from './adsTierManagement/route'
import uploadDataManagementRoute from './uploadDataManagement/route'
import jobPostingManagementRoute from './jobPostingManagement/route'
import exportDataManagementRoute from './exportDataManagement/route'
import cashManagementRoute from './cashManagement/route'
import pointsManagementRoute from './pointsManagement/route'
import cashOutManagementRoute from './cashOutManagement/route'
import schoolManagement from './schoolManagement/route'
import majorManagement from './majorManagement/route'
import aiAgentManagement from './aiAgentManagement/route'

const clientAdminRoute = {
  name: 'clientAdminLayout',
  path: '/v-admin/client-admin/',
  component: ManagementLayout,
  meta: {
    isInclude: true,
    breadcrumb: { hidden: true },
    permission: TAB_CATEGORY.CLIENT_ADMIN,
    get title () {
      return i18n.t('admin.client.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.client.tab')
      }
    },
    hasGroup: false
  },
  children: [
    siteMessageManagementRoute,
    jobPostingManagementRoute,
    companyApprovalRoute,
    // {
    //   name: 'customerManagement',
    //   path: '/company-approval-management/',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_COMPANY_APPROVAL',
    //     get title () {
    //       return i18n.t('admin.customer.customerManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.customerManagement.menu')
    //       }
    //     }
    //   }
    // },
    adsTierManagementRoute,
    cashManagementRoute,
    pointsManagementRoute,
    cashOutManagementRoute,
    // {
    //   name: 'pointsManagement',
    //   path: '/referral/admin/points-management/',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_COMPANY_APPROVAL',
    //     get title () {
    //       return i18n.t('admin.customer.pointsManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.pointsManagement.menu')
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'cashManagement',
    //   path: '/referral/admin/cash-management/',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_COMPANY_APPROVAL',
    //     get title () {
    //       return i18n.t('admin.customer.cashManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.cashManagement.menu')
    //       }
    //     }
    //   }
    // },
    // {
    //   name: 'cashOutManagement',
    //   path: '/referral/admin/cashout-management/',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_COMPANY_APPROVAL',
    //     get title () {
    //       return i18n.t('admin.customer.cashOutManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.cashOutManagement.menu')
    //       }
    //     }
    //   }
    // },
    serviceAccountManagementRoute,
    uploadDataManagementRoute,
    schoolManagement,
    candidateStatusManagementRoute,
    // {
    //   name: 'superCandidateStatusManagement',
    //   path: '/candidate-status-list',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_ADMIN_STATUS_MANAGE',
    //     get title () {
    //       return i18n.t('admin.customer.candidateStatusManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.candidateStatusManagement.menu')
    //       }
    //     }
    //   }
    // },
    majorManagement,
    // {
    //   name: 'majorManagement',
    //   path: '/major-tag-management/',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_ADMIN_MAJOR_MANAGE',
    //     get title () {
    //       return i18n.t('admin.customer.majorManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.majorManagement.menu')
    //       }
    //     }
    //   }
    // },
    exportDataManagementRoute,
    sourceChannelManagementRoute,
    // {
    //   name: 'superUserManagement',
    //   path: '/user-management/delete',
    //   component: null,
    //   meta: {
    //     permission: 'PERM_VIEW_SUPER_PERMISSION',
    //     get title () {
    //       return i18n.t('admin.customer.userManagement.title')
    //     },
    //     menu: {
    //       get label () {
    //         return i18n.t('admin.customer.userManagement.menu')
    //       }
    //     }
    //   }
    // },
    userManagementRoute,
    defaultNotificationManagement,
    ajingaPolicyManagement,
    jobPostRecordRoute,
    openApiRoute,
    aiAgentManagement
  ]
}

export default clientAdminRoute
